var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkillsInitialsE(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 24,
    rx: 12,
    fill: "#4DD3FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4 14.1862C19.4 11.8253 17.5266 9.90063 15.1841 9.82293V5.6001C12.8237 5.6001 10.8995 7.47392 10.8218 9.81696H6.59998C6.59998 12.1779 8.47336 14.1025 10.8158 14.1803V18.4001C13.1763 18.4001 15.1004 16.5263 15.1781 14.1832H19.4V14.1862Z",
    fill: "#D2F4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7436 16V7.27273H28.2152V8.40625H24.0604V11.0653H27.9297V12.1946H24.0604V14.8665H28.2663V16H22.7436Z",
    fill: "#071B22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsInitialsE);
export default __webpack_public_path__ + "static/media/Skills Initials E.c06005818287847ffe59d94545b3b625.svg";
export { ForwardRef as ReactComponent };